import { useEffect, useRef } from "react";

/**
 * Trailing-edge debounce of `save` while `isDirty`, plus a beforeunload guard so
 * closing the tab does not silently drop in-progress notes. `save` is read from a
 * ref so the effect does not retrigger on every render of an inline callback.
 */
export function useAutosave({ value, isDirty, save, delay = 800 }) {
  const saveRef = useRef(save);
  useEffect(() => { saveRef.current = save; });

  useEffect(() => {
    if (!isDirty) return undefined;
    const handle = setTimeout(() => { saveRef.current(); }, delay);
    return () => clearTimeout(handle);
  }, [value, isDirty, delay]);

  useEffect(() => {
    if (!isDirty) return undefined;
    const onBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => window.removeEventListener("beforeunload", onBeforeUnload);
  }, [isDirty]);
}
